// import library
import Swal from "sweetalert2";

// Returns the logged-in user's company id (from /Auth/credentials). When it is missing, the
// pages that send company_id to the API alert the user instead of silently sending "".
export const getUserCompany = (userInfo) => {
    const userCompany = userInfo && userInfo.userCompany;
    if (!userCompany) {
        Swal.fire({
            title: "Company not found",
            text: "No company is assigned to your account. Please contact support.",
            icon: "error",
        });
        return "";
    }
    return userCompany;
};

// Returns the company apiKey (from GetCompanyInfo). Same behavior as getUserCompany: alert on null.
export const getApiKey = (userInfo) => {
    const apiKey = userInfo && userInfo.apiKey;
    if (!apiKey) {
        Swal.fire({
            title: "API key not found",
            text: "No API key is available for your company. Please contact support.",
            icon: "error",
        });
        return "";
    }
    return apiKey;
};
